import { setCurrentUser } from "utils/utils";
import { API_ENDPOINT } from "./Api";
import requestInstance from "./Request";

let env = process.env.REACT_APP_B2B_API_BASE_URL;

export const getReservationListService = async (payload) => {
  const payloadData = {
    search: payload?.search || "",
    status:  payload?.status || "",
    tripType: payload?.tripType || "",
    bookingType:  payload?.bookingType ||"",
    pageSize:  payload?.pageSize || "",
    dateFrom:  payload?.dateFrom || "",
    dateTo:  payload?.dateTo || "",
    type:  payload?.type || payload?.location,
    location: payload?.city || "",
    parentCompany: payload?.parentCompany || '',
    companyId: payload?.companyId || '',
  };
  const page = payload?.page === 0 || payload?.page ? payload?.page + 1 : 1;

  let url = "";
  if (payload.id) {
    url = `${env}${API_ENDPOINT.reservation.reservationApi}/${payload?.id}`;
  } else if (payload?.type || payload?.carTypeId) {
    url = `${env}${
      API_ENDPOINT.reservation.reservationApi +
      "?search=" +
      payloadData?.search +
      "&bookingType=" +
      payloadData?.bookingType +
      "&page=" +
      page +
      "&status=" +
      payloadData?.status +
      "&tripType=" +
      payloadData?.tripType +
      "&pageSize=" +
      payloadData?.pageSize +
      "&dateTo=" +
      payloadData?.dateTo +
      "&dateFrom=" +
      payloadData?.dateFrom +
      "&type=" +
      payload?.type
    }`;
  }else if (payload?.report) {
    url = `${env}${
      API_ENDPOINT.reservation.reservationApi +
      "?page=" +
      page +
      "&reports=true" +
      "&isB2B=true" +
      "&status=" +
      payloadData?.status +
      "&tripType=" +
      payloadData?.tripType +
      "&pageSize=" +
      payloadData?.pageSize +
      "&dateTo=" +
      payloadData?.dateTo +
      "&dateFrom=" +
      payloadData?.dateFrom +
      "&type=" +
      payload?.location +
      "&location=" +
      payload?.city +
      "&parentCompanyId=" +
      (payload?.parentCompany) +
      "&companyId=" +
      (payload?.companyId)
    }`;
  }else if (payload?.export) {
    url = `${env}${
      API_ENDPOINT.reservation.reservationApi +
      "?page=" +
      page +
      "&export=true" +
      "&isB2B=true" +
      "&status=" +
      payloadData?.status +
      "&tripType=" +
      payloadData?.tripType +
      "&pageSize=" +
      payloadData?.pageSize +
      "&dateTo=" +
      payloadData?.dateTo +
      "&dateFrom=" +
      payloadData?.dateFrom +
      "&type=" +
      payload?.location +
      "&parentCompanyId=" +
      (payload?.parentCompany) +
      "&companyId=" +
      (payload?.companyId)+
      "&location=" +
      (payload?.city) 
    }`;
  } else {
    url = `${env}${
      API_ENDPOINT.reservation.reservationApi +
      "?search=" +
      payloadData?.search +
      "&bookingType=" +
      payloadData?.bookingType +
      "&page=" +
      page +
      "&status=" +
      payloadData?.status +
      "&tripType=" +
      payloadData?.tripType +
      "&pageSize=" +
      payloadData?.pageSize +
      "&dateTo=" +
      payloadData?.dateTo +
      "&dateFrom=" +
      payloadData?.dateFrom
    }`;
  }

  const res = await requestInstance.get(url).catch((err) => err.response);
  return setCurrentUser(res);
};

export const getReservationDetailsService = async (payloadId) => {
  const res = await requestInstance
    .get(`${env}${API_ENDPOINT.reservation.reservationApi}/${payloadId?.id || payloadId}`)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const addReservation = async (data) => {
  const res = await requestInstance
    .post(`${env}${API_ENDPOINT.reservation.bookingApi}`, data)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const updateReservation = async (payloadData, payloadId) => {
  let data = {};
  let id = "";

  if (payloadData?.formData?.type) {
    data = payloadData?.formData;
    id = payloadData?.id;
  } else {
    data = payloadData;
    id = payloadId;
  }

  const res = await requestInstance
    .patch(`${env}${API_ENDPOINT.reservation.bookingApi}/${id}`, data)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const getCancelReasonService = async (payload) => {
  const res = await requestInstance
    .get(`${env}${API_ENDPOINT.reservation.cancelReasonApi}`)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const getBookingBufferTimeService = async (payload) => {
  const res = await requestInstance
  .get(`${env}${API_ENDPOINT.reservation.bufferTimeApi}/?type=${payload?.type}`)
  .catch((err) => err.response);
  return setCurrentUser(res);
}

export const getAirportTerminalListService = async (payload) => {
  const res = await requestInstance
  .get(`${env}${API_ENDPOINT.reservation.bufferTimeApi}/?type=${payload?.type}&sourceAddress=${payload?.sourceAddress}`)
  .catch((err) => err.response);
  return setCurrentUser(res);
}